export const hasRole = (roles, role) => {
  if (typeof roles === "string") return roles === role;
  if (Array.isArray(roles)) return roles.includes(role);
  return false;
};

export const getMatchedRoleConfig = (roles, roleConfig) => {
  const matchedRole = Object.keys(roleConfig).find(
    (role) => role !== "default" && hasRole(roles, role),
  );

  return matchedRole ? roleConfig[matchedRole] : roleConfig.default;
};
